import { Link, useParams } from "react-router-dom";
import Content1 from "./sub/Content1";
import { Helmet } from "react-helmet";
import Header from "../../common/Header";
import Footer from "../../common/Footer";
import Section from "../../common/Section";
import Content2 from "./sub/Content2";
import ContentLanding from "./sub/ContentLanding";
import Content4 from "./sub/Content4";
import Content3 from "./sub/Content3";
import { useSelector } from "react-redux";

const contentComponents = {
  undefined: ContentLanding,
  1: Content1,
  2: Content2,
  3: Content3,
  4: Content4
};

function CustomerStoriesPage() {
  let { id } = useParams();

  const ContentComponent = contentComponents[id];
  const user = useSelector((state: any) => state.userReducer.user);
  return (
    <div className="customer-stories">
      {!user && (
        <>
          <Header location="other" />
          <Helmet>
            <title>Turgoil - Kliendilood ja uudised</title>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, user-scalable=no"
            />
          </Helmet>
          <Section backgroundColor="white">
            <div className="information-page__title">
              <Link
                to="/article/et-EE/"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Kliendilood ja uudised
              </Link>
            </div>
          </Section>
        </>
      )}
      <Section backgroundColor="#fff">
        <div>
          {ContentComponent ? <ContentComponent /> : <p>Content not found.</p>}
        </div>
      </Section>
      {!user && (
        <>
          <Footer rootFolder="../../../" />
        </>
      )}
    </div>
  );
}
export default CustomerStoriesPage;
